import { FlightTicketProposalStatusEnum } from 'utils/constants';
import { useFetch } from 'utils/sdk';

export type IFlightTicketRequest = {
  id: number;
  computed_status: FlightTicketProposalStatusEnum;
  amount_of_people: number;
};

export const useFlightTicketRequests = () =>
  useFetch<IFlightTicketRequest[]>('api/customer-facing/flight-ticket-requests/');

export type ITravelRequestPerson = {
  salutation: string;
  first_name: string;
  surname: string;
  date_of_birth: string;
};

export type IFlightTicketProposal = {
  id: number;
  status: FlightTicketProposalStatusEnum;
  price_eur: string;
  arrival_flight_date: string;
  return_flight_date: string;
  expiration_datetime: string;
  travel_request_people: ITravelRequestPerson[];
  flight_ticket_proposal_pdf: {
    id: number;
    name: string;
    url: string;
  };
  is_extension_requested: boolean;
  default_currency: string;
  flight_tickets_pdf: null | {
    id: number;
    name: string;
    url: string;
  };
};

export const useFlightTicketProposal = (id?: string) =>
  useFetch<IFlightTicketProposal>(id ? `api/customer-facing/flight-ticket-proposals/${id}` : null);
